import { render, staticRenderFns } from "./OpenToWorkTabs.vue?vue&type=template&id=ed4909da&scoped=true"
import script from "./OpenToWorkTabs.vue?vue&type=script&lang=js"
export * from "./OpenToWorkTabs.vue?vue&type=script&lang=js"
import style0 from "./OpenToWorkTabs.vue?vue&type=style&index=0&id=ed4909da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4909da",
  null
  
)

export default component.exports